module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** AboutMe Widget must be moved to other folder */

(function(fox) {
	var Promise = fox.RSVP.Promise;

	fox.registerWidget('AboutMe', {
		configure: function () {
			this.registerOptions('', {
				fetchOnRunning: true,
				widgets: {
					dataApi: {
						widget: 'Api',
						method: 'Client_Aboutme.getData',
						cacheChannel: 'site'
					},
					totalApi: {
						widget: 'Api',
						method: 'site.totalPublished',
						cacheChannel: 'content'						
					}
				},
				container: '#block_top.detail',
				'autoRender': false,
				'template': 'sitepage_aboutme_data'
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			if (this.getOption('fetchOnRunning')) {
				this.fetchData();
			}

			this.callParent('running', arguments);
		},

		activate: function () {
			this.fetchTotal();
			this.callParent('activate', arguments);
		},

		fetchAllData: function () {
			return Promise.all([
				this.fetchData(),
				this.fetchTotal()
			]).catch(console.error.bind(console));
		},

		fetchData: function () {
			return this.rwom1('#dataApi').psend({}).then(this.apiSuccessHandler.bind(this));
		},

		fetchTotal: function () {
			return this.rwom1('#totalApi').psend({});
		},

		apiSuccessHandler: function (resp) {
			var success = fox.objectGet(resp, 'params.answer.response.success');
			var stats = success.stats;
			
			if (fox.isSet(success.publicActivity)) {
				this.sortingPublicActivityByYear(success.publicActivity);
			}

			if (fox.isSet(stats.data)) {
				this.checkDataForStats(stats);
			}

			this.renderData(success);

			return resp;
		},

		sortingPublicActivityByYear: function(obj) {
			var movies = obj.movie,
				awards = obj.award;

			obj.movie = (fox.isSet(movies)) ? fox.toArray(movies).sort(this.sortingMoviesByYear) : '';
			obj.award = (fox.isSet(awards)) ? fox.toArray(awards).sort(this.sortingAwardsByYear) : '';			
		},

		sortingMoviesByYear: function(obj1, obj2) {
			var yearObj1 = +obj1['yearMovie'],
				yearObj2 = +obj2['yearMovie'];

			return yearObj2 - yearObj1;
		},

		sortingAwardsByYear: function(obj1, obj2) {
			var yearObj1 = +obj1['yearAward'],
				yearObj2 = +obj2['yearAward'];

			return yearObj2 - yearObj1;
		},

		renderData: function (data) {
			this
				.setTemplateOptions(data)
				.render();
		},

		checkDataForStats: function (stats) {
			var state = false;

			fox.each(stats.data, function (row, i) {
				if (fox.isEmpty(row.value)) {
					return;
				};

				state = true;
			});

			stats.statsDataExists = state;
		}
	
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/aboutme.js
// module id = 795
// module chunks = 4